import { AccountType, Address, Contact } from '../../shared';
import { castAs } from '../../shared/core/util';
import { PrejudiceEvaluableEnArgent, RaisonAvisDimpositionIrregulier,
    RaisonContestation, RaisonInvalidationTitre } from '../contentieux-social';
import { PieceComplementaireOrigineType } from '../piece-jointe';
import { PartieDepot, RequeteCategory } from '../requete/requete.model';
import { TypeActeAttaque } from '../type-acte-attaque';

export enum Statut {
    AVERTISSEMENT = 'AVERTISSEMENT',
    REQUERANT = 'REQUERANT',
    JURIDICTION = 'JURIDICTION',
    REQUETE = 'REQUETE',
    JUSTIFICATIF = 'JUSTIFICATIF',
    RECAPITULATIF = 'RECAPITULATIF'
}
export class DraftRequete {
    id: number;
    userId: number;
    typeRequeteId: number;
    siteJuridictionId: number;
    typeJuridictionId: number;
    typeActeAttaque: TypeActeAttaque;
    concernContentieuxSocial: boolean;
    contentieuxSocialId: number;
    formActivated: boolean;
    statut: string;
    dateCreation: Date;
    category: RequeteCategory;
    parties?: PartieDepot[];
    pieces?: DraftPieceJointe[];
    version: number;

    static castAs(draft: object): DraftRequete {
        const draftRequete: DraftRequete = castAs<DraftRequete>(draft, DraftRequete);
        draftRequete.parties = (draftRequete.parties || []).map(partie =>
            castAs<PartieDepot>(partie, PartieDepot)
        );
        draftRequete.pieces = draftRequete.pieces || [];
        return draftRequete;
    }

    public getIndexStateFromDraft(): number {
        switch (this.statut) {
            case Statut.AVERTISSEMENT:
                return 0;
            case Statut.REQUERANT:
                return 1;
            case Statut.JURIDICTION:
                return 2;
            case Statut.REQUETE:
                return 3;
            case Statut.JUSTIFICATIF:
                return 4;
            case Statut.RECAPITULATIF:
                return 5;
            default:
                return 0;
        }
    }
}

export class DraftRequeteSummary {
    id: number;
    dateCreation: Date;
}

export interface PartieDepotDraft {}

export class Requerant implements PartieDepotDraft {
    type?: AccountType;
    civilite?: string;
    firstName?: string;
    lastName?: string;
    nomEntreprise?: string;
    sigleEntreprise?: string;
    address: Address = {} as Address;
    contact: Contact = {} as Contact;
}

export class Juridiction {
    typeRequeteId: number; // TODO: TRC-816 à enlever
    siteJuridictionId: number;
    typeJuridictionId: number;
    typeActeAttaque: string;
}

export class RequeteContentieuxSocial {
    typeRequeteId: number;
    contentieuxSocial: boolean;
    hasDocument: boolean; // décision attaquée
    raisonSansDocument: string; // raison sans la décision attaquée
    souhait: string;
    typeLitige: string;
    nomsAdministrations: string;
    objetDemande: string; // titre de demande
    precisionDemande: string; // Obselete
    motifs: string;
    contexteInterventionDecision: string;
    conclusionDALO: string;
    conclusionLitigeAdminCheckbox: boolean;
    conclusionLitigeAdmin: string;
    raisonContestations: Array<RaisonContestation>;
    // reclamer une somme
    pourquoiSommeDue: string;
    montantDuMontant: number;
    conclusionReclamerSommeCondamnerAdmin: boolean;
    conclusionReclamerSommeMajoree: boolean;
    // contester une somme
    typeActe: string;
    raisonAvisDimpositionIrreguliers: Array<RaisonAvisDimpositionIrregulier>;
    faitConduitAuLitige: string;
    raisonPasPayerImpot: string;
    conclusionAvisImpositionImpot: boolean;
    raisonInvalidationTitres: Array<RaisonInvalidationTitre>;
    conclusionContesterSommeTitreEmisIrregulierDes: boolean;
    conclusionContesterSommeTitreEmisIrregulierMontant: number;
    // indemnisation
    faitConduitSituationReparation: string;
    prejudiceEvaluableEnArgents: Array<PrejudiceEvaluableEnArgent>;
    precisionPrejudice: string;
    originePrejudice: string;
    conclusionIndemnisationCondamnerAdmin: boolean;
    conclusionIndemnisationMontant: number;
    conclusionIndemnisationMajoree: boolean;
    piecesAttachees: Array<DraftPieceJointe>;
}

export class Justificatifs {
    piecesNotPostales: Array<DraftPieceJointe>;
    piecesPostales: Array<DraftPieceJointe>;
}

export class DraftPieceJointe {
    fileApiId?: string;
    fileName?: string;
    fileType: string;
    fileSize?: number;
    libelle: string;
    createdFromHash?: string;
    complementaryFileOriginType?: PieceComplementaireOrigineType;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/draft-requete/draft-requete.model.ts